import { render, staticRenderFns } from "./mzj_HomeView.vue?vue&type=template&id=45afe9a8&scoped=true&"
import script from "./mzj_HomeView.vue?vue&type=script&lang=js&"
export * from "./mzj_HomeView.vue?vue&type=script&lang=js&"
import style0 from "./mzj_HomeView.vue?vue&type=style&index=0&id=45afe9a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afe9a8",
  null
  
)

export default component.exports